import React from 'react';
import { Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const getProductosDeCotizacion = (c) => {
  if (Array.isArray(c.productos) && c.productos.length > 0) return c.productos;
  return [
    {
      productoId: c.productoId,
      productoNombre: c.productoNombre,
      posicionArancelaria: c.posicionArancelaria,
      conceptosGrilla: c.conceptosGrilla || [],
    },
  ];
};

/** Celda que agrupa filas de la misma cotización (rowSpan). */
export const renderCeldaAgrupada = (row, content) => {
  if (row._esFilasProductoSecundario) {
    return { props: { rowSpan: 0 } };
  }
  return {
    children: content,
    props: { rowSpan: row._rowSpanCotizacion },
  };
};

/** Filas visibles: 1 por cotización colapsada; N si está expandida (alineación nativa de tabla). */
export const buildFilasGrillaCotizaciones = (cotizaciones, expandedIds) => {
  const expanded = expandedIds instanceof Set ? expandedIds : new Set(expandedIds || []);
  const out = [];

  for (const c of cotizaciones || []) {
    const prods = getProductosDeCotizacion(c);
    const isExpanded = expanded.has(c.id);
    const visibleProds = isExpanded ? prods : [prods[0]];
    const rowSpan = isExpanded ? prods.length : 1;

    visibleProds.forEach((p, idx) => {
      out.push({
        key: `${c.id}-p-${p.productoId ?? idx}`,
        ...c,
        productoNombre: p.productoNombre,
        posicionArancelaria: p.posicionArancelaria,
        conceptosGrilla: p.conceptosGrilla || [],
        _esFilasProductoSecundario: idx > 0,
        _rowSpanCotizacion: idx === 0 ? rowSpan : 0,
        _totalProductos: prods.length,
        _productoIndex: idx,
      });
    });
  }

  return out;
};

/** Columna Nº con botón +/- para expandir productos adicionales. */
export const renderColumnaNumeroConExpand = (v, row, onToggleExpand) => {
  if (row._esFilasProductoSecundario) {
    return { props: { rowSpan: 0 } };
  }
  const nro = v ?? row.id ?? '—';
  return {
    props: { rowSpan: row._rowSpanCotizacion },
    children:
      row._totalProductos > 1 ? (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
          <Button
            type="text"
            size="small"
            icon={row._rowSpanCotizacion > 1 ? <MinusOutlined /> : <PlusOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onToggleExpand(row.id);
            }}
            aria-label={row._rowSpanCotizacion > 1 ? 'Ocultar productos' : 'Ver más productos'}
          />
          {nro}
        </span>
      ) : (
        nro
      ),
  };
};

/** Títulos de columnas de conceptos a partir de todos los productos de la página. */
export const titulosConceptosDesdeCotizaciones = (cotizaciones) => {
  const ordenPorNombre = new Map();
  (cotizaciones || []).forEach((c) => {
    getProductosDeCotizacion(c).forEach((p) => {
      (p.conceptosGrilla || []).forEach((l) => {
        const nombre = l.nombre;
        if (!nombre) return;
        const orden = l.orden ?? 0;
        if (!ordenPorNombre.has(nombre)) ordenPorNombre.set(nombre, orden);
        else ordenPorNombre.set(nombre, Math.min(ordenPorNombre.get(nombre), orden));
      });
    });
  });
  return Array.from(ordenPorNombre.entries())
    .sort((a, b) => a[1] - b[1] || String(a[0]).localeCompare(String(b[0])))
    .map(([nombre]) => nombre);
};
